/**
 * API service for the Volumes and WIP page
 */
import { store } from "../../store";
import { apiRequest } from "../../services/apiMiddleware";
import { API_GATEWAY_PROCESS_NAME } from "../../utils/constants";
import { showError } from "../../store/slices/errorSlice";
import {
  GetTargetAndWIPVolumeRequest,
} from "./model";
import {
  GET_TARGET_AND_WIP_VOLUMES_API,
  logOperationalMetric,
  MetricType,
  RCC_SHIFT_PLAN_VOLUMES_AND_WIP_TAB,
} from "../../utils/metric-utils";

/**
 * Common error handler for getTargetAndWIPVolumes
 * @param errorSource - Either response object or error object
 */
const handleGetTargetAndWIPVolumesError = (errorSource: any): never => {
  const errorMessage = errorSource.errorResponse || errorSource.message || "Unable to fetch volumes data. Please try again later.";

  store.dispatch(showError({
    title: "Failed to fetch Target and WIP Volumes",
    message: errorMessage,
  }));

  throw new Error(errorMessage);
};

export const getTargetAndWIPVolumes = async (
  request: GetTargetAndWIPVolumeRequest
) => {
  const startTime = Date.now();
  const stationCode = request.warehouseId || '';
  let metricLogged = false;
  try {
    const requestPayload = {
      resourcePath: "/getTargetAndWIPVolume",
      httpMethod: "post",
      processName: API_GATEWAY_PROCESS_NAME,
      requestBody: request,
    };
    const response = await apiRequest(requestPayload);

    // Check if the response indicates an error
    if (response.status && response.status >= 400) {
      logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_VOLUMES_AND_WIP_TAB, GET_TARGET_AND_WIP_VOLUMES_API, MetricType.FAILED, response);
      metricLogged = true;
      return handleGetTargetAndWIPVolumesError(response);
    }

    logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_VOLUMES_AND_WIP_TAB, GET_TARGET_AND_WIP_VOLUMES_API, MetricType.SUCCESS);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching Target and WIP volumes:", error);
    if (!metricLogged) {
      logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_VOLUMES_AND_WIP_TAB, GET_TARGET_AND_WIP_VOLUMES_API, MetricType.FAILED, error);
      return handleGetTargetAndWIPVolumesError(error);
    }
    throw error;
  }
};
